import { mensagemPadrao } from 'src/dados-estaticos'
import { PrecificacaoCategoria } from 'src/tipos/precificacao'
import * as Yup from 'yup'

const mensagemDataPassado =
  'A data não pode ser anterior a hoje - uma data de início no passado nunca é ativada automaticamente (o sistema só ativa planos exatamente no dia informado).'

// Compara só a parte de data (ignora hora) no formato dd/mm/aaaa usado pelo
// CalendarioUnform desta tela.
const naoEhDataPassada = (valor?: string) => {
  if (!valor) return true

  const [dia, mes, ano] = valor.split('/').map(Number)
  if (!dia || !mes || !ano) return true

  const dataInformada = new Date(ano, mes - 1, dia)
  const hoje = new Date()
  hoje.setHours(0, 0, 0, 0)

  return dataInformada >= hoje
}

// permitirDataPassada: true no modo Edição - uma precificação já existente
// pode legitimamente ter DataInicio/DataFim no passado (ex.: editar só o
// nome, sem mexer nas datas), e bloquear isso quebraria edições normais. A
// regra de "não aceitar data passada" só faz sentido ao criar algo novo.
export const criarSchema = (permitirDataPassada: boolean) =>
  Yup.object().shape({
    nome: Yup.string().required(mensagemPadrao),
    codigo: Yup.string().required(mensagemPadrao),
    cpf: Yup.string().notRequired(),
    // Base nunca depende de data (vale até outra base assumir). Cpf e
    // Campanha Pós sempre exigem data: Cpf para vigência da negociação
    // individual, Campanha Pós para delimitar a janela temporária sem mexer
    // na Base. Campanha Extensão só exige data quando NÃO é o valor padrão
    // do curso - marcada como padrão (precificacaoBase=true), ela vale
    // indefinidamente como a Base institucional do curso, mesma regra de Base.
    //
    // Datas no passado são bloqueadas na criação porque o backend só ativa
    // um plano não-base quando DataInicio é EXATAMENTE hoje
    // (CriarPlanoPagamentoCommandHandler) e o job diário repete a mesma
    // regra - uma precificação criada com DataInicio já vencida nunca é
    // ativada automaticamente depois, ficando presa como Inativa para sempre
    // (incidente real: Campanha Pós "campanha-outubro-40", id
    // 76b66962-f857-4732-ab45-be316bd7c2d0).
    dataInicio: Yup.string()
      .when(['categoria', 'precificacaoBase'], {
        is: (categoria, precificacaoBase) =>
          categoria === PrecificacaoCategoria.Base ||
          (categoria === PrecificacaoCategoria.CampanhaExtensao && precificacaoBase),
        then: schema => schema.notRequired(),
        otherwise: schema => schema.required(mensagemPadrao)
      })
      .test(
        'nao-eh-data-passada',
        mensagemDataPassado,
        valor => permitirDataPassada || naoEhDataPassada(valor)
      ),
    dataFim: Yup.string()
      .when(['categoria', 'precificacaoBase'], {
        is: (categoria, precificacaoBase) =>
          categoria === PrecificacaoCategoria.Base ||
          (categoria === PrecificacaoCategoria.CampanhaExtensao && precificacaoBase),
        then: schema => schema.notRequired(),
        otherwise: schema => schema.required(mensagemPadrao)
      })
      .test(
        'nao-eh-data-passada',
        mensagemDataPassado,
        valor => permitirDataPassada || naoEhDataPassada(valor)
      ),
    valorBase: Yup.string().when(['categoria', 'precificacaoBase'], {
      is: (categoria, precificacaoBase) =>
        categoria === PrecificacaoCategoria.CampanhaExtensao && precificacaoBase,
      then: schema => schema.required(mensagemPadrao),
      otherwise: schema => schema.notRequired()
    }),
    pctDesconto: Yup.string().when(['categoria', 'precificacaoBase'], {
      is: (categoria, precificacaoBase) =>
        categoria === PrecificacaoCategoria.CampanhaExtensao && !precificacaoBase,
      then: schema => schema.required(mensagemPadrao),
      otherwise: schema => schema.notRequired()
    }),
    cursoId: Yup.string().required(mensagemPadrao)
  })
